<template>
  <div class="eco-event-info">
    <div class="cols align-items-center">
      <div class="font-bold font-size-15"> {{ $t('reports.trips.eco-events.parking') }} </div>
      <table class="popup-details">
        <tbody>
          <tr>
            <th>{{ $t('dashboard.quick-map.info-window.address') }}</th>
            <td>{{ address }}</td>
          </tr>
          <tr v-if="duration">
            <th>{{ $t('reports.trips.eco-events.event-stop-info.duration') }}</th>
            <td>{{ duration }}</td>
          </tr>
          <tr v-if="time">
            <th>{{ $t('reports.trips.eco-events.event-info.time') }}</th>
            <td>{{ time }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EcoEventsStopInfo',
  props: {
    address: String,
    duration: String,
    time: String,
  },
};
</script>

<style scoped lang="scss">
.eco-event-info {
  background: #FFFFFF;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
}
</style>
